/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import configJson from '../../../../../../../config/config.json';
import TokenPrice, {
  displaySmallFLoats,
} from '../../../../../../Common/SliderTokensList/SliderToken/TokenPrice/TokenPrice';
import ShowAt from '../../../../../../Common/ShowAt/ShowAt';
import { divideOnWei } from '../../../../../../../utils/mapper';
import SignStatus from '../../../SignTradeOrders/SignStatus/SignStatus';

const orderTypeMapper = {
  BUY_LIMIT: 'Limit Buy',
  SELL_LIMIT: 'Limit Sell',
  STOP_LOSS: 'Stop Loss',
};

const removeDayFromDate = (date = '') => {
  const splitted = date.split(' ');
  splitted.shift();
  return splitted.join(' ');
};

const BuyLimitAmount = ({ record }) => (
  <span className="white-space-pre">
    {displaySmallFLoats(record.token_amount_at_creation, 6)} {configJson.baseCoin}
  </span>
);
const SellLimitAmount = ({ record }) => (
  <span className="white-space-pre">
    {displaySmallFLoats(record.token_amount, 6)} {record.token_symbol}
  </span>
);

const typeAmountMapper = {
  BUY_LIMIT: BuyLimitAmount,
  SELL_LIMIT: SellLimitAmount,
  STOP_LOSS: SellLimitAmount,
};

const orderTypeToTokenAmount = (record) => {
  const TokenAmount = typeAmountMapper?.[record.order_type];
  return <TokenAmount record={record} />;
};

const OrderStatus = ({ record }) => (
  <>
    <>{record?.is_activated && 'Partial Fill'}</>
    <>{record?.is_executed && 'Finished'}</>
    <>{!record?.is_executed && !record?.is_activated && 'Live'}</>
  </>
);
OrderStatus.propTypes = {
  record: PropTypes.object.isRequired,
};

export const openOrdersCols = ({ onCancel = () => {}, deleteLoading, signInfo }) => [
  {
    id: 'order_type',
    title: 'Order Type',
    render: (record) => <span className="white-space-pre">{orderTypeMapper?.[record.order_type]}</span>,
  },
  {
    id: 'token_pair',
    title: 'Pair',
  },
  {
    id: 'price_usd_wei',
    title: 'Price',
    default: 0,
    render: (record, price) => (
      <ShowAt at={!!price}>
        <span className="token-price-in-usd">${divideOnWei(price)}</span>
      </ShowAt>
    ),
  },
  {
    // token amount is based on order type
    id: 'token_amount_at_creation',
    title: 'Amount',
    render: (record, tokenAmount) => <span>{orderTypeToTokenAmount(record)}</span>,
  },
  {
    id: 'status',
    title: 'Status',
    render: (record) => <OrderStatus record={record} />,
  },
  {
    id: 'time',
    title: 'Time',
    render: (record) => (
      <span className="white-space-pre">{removeDayFromDate(new Date(record.valid_until)?.toDateString())}</span>
    ),
  },
  // {
  //   id: 'is_signed',
  //   title: '',
  //   render: (record, isSigned) => (
  //     <ShowAt at={!isSigned}>
  //       <SignStatus
  //         tokenAddress={record.token_address}
  //         tokenRatio={record.token_ratio}
  //         tokenId={record.id}
  //         isExecuted={record.is_executed}
  //         tradeOrderId={record.id}
  //         token={record}
  //         signMethod={signInfo.signMethod}
  //         loading={signInfo.loading}
  //       />
  //     </ShowAt>
  //   ),
  // },
  {
    id: 'cancel',
    title: '',
    render: (record) => (
      <ShowAt at={!record?.is_executed && !record?.is_activated}>
        <span className="cancel-btn" onClick={() => onCancel(record.id)}>
          {deleteLoading ? 'Deleting' : 'Cancel'}
        </span>
      </ShowAt>
    ),
  },
];
